import { render, staticRenderFns } from "./ImageZoomer.vue?vue&type=template&id=30681f4a&scoped=true&"
import script from "./ImageZoomer.vue?vue&type=script&lang=ts&"
export * from "./ImageZoomer.vue?vue&type=script&lang=ts&"
import style0 from "./ImageZoomer.vue?vue&type=style&index=0&id=30681f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30681f4a",
  null
  
)

export default component.exports